import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'e5core-ui-timepicker',
  template: `<e5core-ui-timepicker-material [displayedTime]="displayedTime" (keyup)="onKeyUp($event)"></e5core-ui-timepicker-material>`
})
export class E5coreUiTimepickerComponent implements OnInit {

  @Input() displayedTime:string
  @Output() public timeChange: EventEmitter<any>
  constructor() { }

  ngOnInit() {
  }

  public onKeyUp(event: any) 
  {
    this.timeChange.emit(event.target.value);
  }

}
